import { useRegisterSW } from 'virtual:pwa-register/react';
import { RefreshCw, X } from 'lucide-react';

export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  const close = () => {
    setNeedRefresh(false);
  };

  // Only display floating prompt when a new version of the app is available
  if (!needRefresh) return null;

  return (
    <div className="fixed bottom-20 md:bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 z-50 animate-slide-up">
      <div className="bg-surface border border-border rounded-xl shadow-lg p-3.5 flex items-center gap-3">
        <div className="w-8 h-8 rounded-lg bg-brand-primary/10 text-brand-primary flex items-center justify-center shrink-0">
          <RefreshCw size={16} />
        </div>
        <p className="flex-1 text-xs text-text-primary font-medium">
          Nueva versión disponible
        </p>
        <button
          type="button"
          onClick={() => updateServiceWorker(true)}
          className="px-2.5 py-1 bg-brand-primary text-white text-xs font-semibold rounded-lg hover:bg-brand-primary-light transition-colors cursor-pointer"
        >
          Actualizar
        </button>
        <button
          type="button"
          onClick={close}
          className="p-1 text-text-muted hover:text-text-primary rounded-md cursor-pointer transition-colors"
          aria-label="Cerrar"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}

